import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-6 bg-terracotta text-white text-center" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <FadeIn data-id="element-35">
          <h2 className="font-serif text-3xl md:text-5xl mb-8" data-id="element-36">
            ¿Lista para sentirte cómoda en tu propia piel otra vez?
          </h2>
          <Button href="https://www.plenavital.com/cart/48387544416481:1" className="bg-white text-terracotta hover:bg-cream mb-6 py-5 px-10 text-xl w-full sm:w-auto" data-id="element-37">
            QUIERO MI RESET METABÓLICO AHORA
          </Button>
          <div className="flex items-center justify-center gap-6 text-sm text-white/80 font-medium" data-id="element-38">
            <span className="flex items-center gap-2" data-id="element-39">
              <ShieldCheck size={18} data-id="element-40" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-41">
              <Zap size={18} data-id="element-42" /> Acceso instantáneo
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}